import React, { useCallback, useEffect, useState } from "react";
import api from "../api";

const errMsg = (e) => e?.response?.data?.message || e?.message || "Request failed";
const when = (d) => (d ? new Date(d).toLocaleString() : "—");
const TONE = { Pending: "warn", Approved: "danger", Denied: "", Revoked: "", Expired: "" };

export default function SupportAccessTenant() {
  const [rows, setRows] = useState([]);
  const [err, setErr] = useState("");
  const [emails, setEmails] = useState("");
  const [msg, setMsg] = useState("");
  useEffect(() => { api.get("/support-access/settings").then((r) => setEmails(r.data?.data?.emails || "")).catch(() => {}); }, []);
  const saveEmails = async (e) => { e.preventDefault(); setMsg(""); try { const r = await api.put("/support-access/settings", { emails }); setEmails(r.data?.data?.emails || ""); setErr(""); setMsg("Saved."); } catch (x) { setErr(errMsg(x)); } };
  const load = useCallback(() => api.get("/support-access").then((r) => setRows(r.data?.data || [])).catch((e) => setErr(errMsg(e))), []);
  useEffect(() => { load(); const i = setInterval(load, 30000); return () => clearInterval(i); }, [load]);
  const act = async (id, what, body) => { try { await api.post(`/support-access/${id}/${what}`, body || {}); setErr(""); load(); } catch (e) { setErr(errMsg(e)); } };
  const approve = (r) => {
    const h = window.prompt(`Allow ${r.requested_by} read-only access for how many hours? (1-${r.requested_hours})`, String(r.requested_hours));
    if (h) act(r.id, "approve", { hours: Number(h) });
  };
  return (
    <div>
      <h1>Vxaro Support Access</h1>
      <p className="sub">Vxaro staff cannot open your data unless you approve it here. An approved session is <b>read-only</b>, lasts only for the hours you allow, and every page they open is recorded in your Audit Log. You can revoke at any time; it stops immediately.</p>
      {err && <div className="err" style={{ marginBottom: 10 }}>{err}</div>}
      {msg && <div className="ok" style={{ marginBottom: 10 }}>{msg}</div>}
      <form onSubmit={saveEmails} className="card" style={{ padding: 12, marginBottom: 14, display: "flex", gap: 10, alignItems: "end", flexWrap: "wrap" }}>
        <div className="form-row" style={{ flex: 1, minWidth: 260 }}><label>E-mail these people when Vxaro asks for access (comma separated)</label><input value={emails} onChange={(e) => setEmails(e.target.value)} placeholder="dpo@bank.in, it-head@bank.in" /></div>
        <button className="btn primary">Save</button>
      </form>
      <div className="card">
        <table>
          <thead><tr><th>Requested</th><th>Staff</th><th>Reason</th><th>Hours asked</th><th>State</th><th>Access until</th><th /></tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id}>
                <td>{when(r.created_at)}</td><td>{r.requested_by}</td><td>{r.reason}</td><td>{r.requested_hours}</td>
                <td><span className={`pill ${TONE[r.state] || ""}`}>{r.state}</span>{r.decided_by && <div className="sub" style={{ margin: 0 }}>by {r.decided_by}</div>}</td>
                <td>{when(r.expires_at)}</td>
                <td>
                  {r.state === "Pending" && <><button className="btn sm primary" onClick={() => approve(r)}>Approve</button> <button className="btn sm" onClick={() => act(r.id, "deny")}>Deny</button></>}
                  {(r.state === "Approved" || r.state === "Pending") && r.state !== "Pending" && <button className="btn sm danger" onClick={() => window.confirm("Revoke now? Any open Vxaro session stops immediately.") && act(r.id, "revoke")}>Revoke</button>}
                </td>
              </tr>
            ))}
            {!rows.length && <tr><td colSpan={7} style={{ textAlign: "center", padding: 20 }}>No requests</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
